import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

// Category - Get All (Read)
export const GetAll = createAsyncThunk(
  "website/all-review/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.ReviewRating.ReviewRating}?name=${filter?.name || ""}&page=${filter?.page || IDS.PAGE
        }&per_page=${filter?.per_page || IDS.PERPAGE}&searchRating=${filter?.searchRating || ""}&email=${filter?.email || ""
        }&contact=${filter?.contact || ""}&start_date=${filter?.startDate || ""
        }&end_date=${filter?.endDate || ""}`
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const toggleComplteStatus = createAsyncThunk(
  "website/all-review/toggleComplteStatus",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.ReviewRating.ReviewRating}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const deleteReviewData = createAsyncThunk(
  "website/all-review/delete",
  async (id, { rejectWithValue }) => {
    try {
      const res = await DELETE(`${APIS.ReviewRating.ReviewRating}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



export const Slice = createSlice({
  name: "review_rating",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetCategory, AddCategory, UpdateCategory, DeleteCategory
      .addCase(GetAll.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAll.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAll.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const { } = Slice.actions;

export default Slice.reducer;
